import OaApiService from './OaApiService';

export default class NoteService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.createUrl = '/NoteREST/create-note';
  }

  getNotes(data) {
    return this.get('/NoteREST/get-notes', data);
  }
}
